import { Component, inject, computed } from '@angular/core';
import { MaterialModule } from '@app/material.module';
import { Router } from '@angular/router';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { CustomSnackBarService } from '@app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { FormsModule } from '@angular/forms';
import { PermissionService } from '@app/services/auth/permission.service';

interface AppMenuItem {
    label: string;
    icon: string;
    route: string;
    disabled: boolean;
    permission?: string; // Permiso requerido para ver esta opción
}

@Component({
    selector: 'app-home',
    imports: [MaterialModule, FormsModule],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
})
export class HomeComponent {
    private permissionService = inject(PermissionService);
    public isLoading = this.permissionService.isLoading;

    search = '';
    apps: AppMenuItem[] = [
        { label: 'Monitor de Órdenes de Surtimiento', icon: 'inventory', route: '/orders-monitor', disabled: false, permission: 'view.orders' },
        { label: 'Monitor Información AVEDI', icon: 'description', route: '/avedi-invoice-monitor', disabled: false, permission: 'view.invoices' },
        { label: 'Monitor Información Externa', icon: 'business', route: '/external-invoice-monitor', disabled: false, permission: 'view.external_invoices' },
        { label: 'Dashboard de Facturas', icon: 'dashboard', route: '/invoice-dashboard', disabled: false, permission: 'view.invoice_dashboard' },
        { label: 'Cargar Documentos Externos', icon: 'cloud_upload', route: '/external-document-upload', disabled: false, permission: 'view.external_documents' },
        { label: 'Procesar Documentos Externos', icon: 'settings_suggest', route: '/external-document-processing', disabled: false, permission: 'view.external_documents' },
        { label: 'Catálogo de Estatus', icon: 'rule', route: '/statuses-viewer', disabled: false, permission: 'view.statuses' },
        { label: 'Catálogo de Operadores Logísticos', icon: 'local_shipping', route: '/logistic-operators', disabled: false, permission: 'view.logistic_operators' },
        { label: 'Configuración de IA', icon: 'settings', route: '/ia-config', disabled: false, permission: 'view.ia_config' },
        { label: 'Usuarios y Roles', icon: 'people', route: '/user', disabled: false, permission: 'view.users' },
    ];

    constructor(private router: Router, private customMessage: CustomMessageService, private customSnackBar: CustomSnackBarService) { }

    ngOnInit() {
        this.customSnackBar.open('Carga correcta', 'info');
    }

    /**
     * @description Filters the applications based on the search term and user permissions.
     * @returns An array of filtered applications that the user has permission to see.
     */
    filteredApps() {
        return this.apps.filter((app) => {
            // Filtro por búsqueda
            const matchesSearch = app.label.toLowerCase().includes(this.search.toLowerCase());

            // Filtro por permisos: si la app requiere permiso, verificar que el usuario lo tenga
            const hasPermission = !app.permission || this.permissionService.hasPermission(app.permission);

            return matchesSearch && hasPermission;
        });
    }

    /**
     * @description Navigates to the specified route.
     * @param route The route to navigate to.
     */
    navigateTo(route: string) {
        this.router.navigate([route]);
    }
}
